import util from './shared/util.js';
import config from '../config.js';
const url = `${config.server.url}:${config.server.webServicesPort}/generated-world/`;
// A persisted failed job is a successful response containing recovery state.
// Its diagnostic string is distinct from the route's structured error envelope.
const isFailedJob = result => typeof result?.id === 'string' && Number.isInteger(result.revision) &&
  ['story', 'completion', 'knowledge'].includes(result.mode) && ['failed', 'planning_failed'].includes(result.status) &&
  typeof result.error === 'string';
const request = (path, data, baseUrl = url) => new Promise((resolve, reject) => util.putJSON(baseUrl + path, data, (err, result) => {
  if (err != null || (result?.error && !isFailedJob(result))) reject(Object.assign(new Error(result?.error?.message || result?.error || 'World generation request failed.'), {
    status: typeof err === 'number' ? err : result?.status ?? err?.status,
    code: result?.error?.code, spatialDiagnostics: result?.error?.spatialDiagnostics }));
  else resolve(result);
}));
const cdoGeneratedWorld = {
  saveEntity: data => request('save-entity', data),
  savePlace: data => request('save-place', data),
  saveRelationships: data => request('save-relationships', data),
  saveCurrencies: data => request('save-currencies', data),
  generateRoutines: data => request('generate-routines', data, `${config.server.url}:${config.server.webServicesPort}/being/`),
  generateEvents: data => request('generate-events', data),
  generateRelationships: data => request('generate-relationships', data),
  planSocialLives: data => request('plan-social-lives', data),
  assessCoverage: data => request('assess-coverage', data),
  suggestNearby: data => request('suggest-nearby', data),
  planSiteInhabitants: data => request('plan-site-inhabitants', data),
  generateFinal: data => request('generate-final', data),
  planStory: data => request('completion-plan', data),
  convertLegacyStory: data => request('story-scope-convert', data),
  previewStoryContext: data => request('story-context-preview', data),
  previewCompletionContext: data => request('completion-context-preview', data),
  planStoryEquipment: data => request('story-equipment-plan', data),
  reviseStoryItemTemplate: data => request('story-item-template-revise', data),
  prepareStoryMapCorrections: data => request('story-map-prepare', data),
  approveStoryMapCorrections: data => request('story-map-approve', data),
  discardStoryMapCorrections: data => request('story-map-discard', data),
  skipStoryAssessmentIssue: data => request('story-assessment-issue-skip', data),
  skipStoryEquipmentReview: data => request('story-equipment-skip', data),
  repairStoryEquipment: data => request('story-equipment-repair', data),
  prepareStorySpatialDetails: data => request('story-spatial-prepare', data),
  approveStorySpatialDetails: data => request('story-spatial-approve', data),
  repairStoryRoutines: data => request('story-routines-repair', data),
  repairStoryItemDrafts: data => request('story-item-drafts-repair', data),
  planCompletion: data => request('completion-plan', data),
  planKnowledge: data => request('knowledge-plan', data),
  listStories: data => request('story-list', data),
  storyStatus: data => request('story-status', data),
  reviseStory: data => request('story-revise', data),
  storyStep: data => request('story-step', data),
  installStory: data => request('story-install', data),
};
export default cdoGeneratedWorld;
